<nav class="horizontal-menu" aria-label="Navigation">
  @for (item of items; track item.label; let i = $index) {
    @if (i > 0) {
      <span class="menu-divider" aria-hidden="true"></span>
    }
    <app-horizontal-menu-item
      [item]="item"
      [active]="selectedIndex === i"
      [tone]="getTone(item.label)"
      (selected)="itemSelected.emit(i)"
    ></app-horizontal-menu-item>
  }
</nav>
